module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.user.uid),
      expression: "!user.uid"
    }],
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    staticClass: "full-width",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "offset-md-4 col-md-4"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "firebaseui-auth-container"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "red",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.user.failedLogin))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11px",
      "line-height": "1.4",
      "text-align": "justify",
      "color": "#666",
      "margin-top": "15px"
    }
  }, [_vm._v("This computer system, including all related equipment, networks, and devices (specifically including internet access), are provided only to customers (\"Customers\") of UNIT Innovations (the \"Company\") for use by each Customer's users. By signing in or using this system, you acknowledge and agree to the terms of that certain Software as a Service (SaaS) License Agreement (the \"Agreement\") with the Company, a copy of which is available at https://www.unitinnovations.com/terms. By continuing to use this system, you indicate your awareness of and consent to the Agreement and are indicating your agreement to be bound by the terms of the Agreement.")])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.uid),
      expression: "user.uid"
    }],
    attrs: {
      "id": "wrapper"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-spark navbar-toggleable"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('button', {
    staticClass: "sidebar-open hidden-md-up",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.mobileSidebarShowing = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("Profile")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/profile"
    }
  }, [_c('i', {
    staticClass: "ion ion-person"
  }), _vm._v(" View Profile")])], 1), _vm._v(" "), _c('li', {
    staticClass: "dropdown-divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', {
    staticClass: "dropdown-divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "ion ion-log-out"
  }), _vm._v(" Sign out")])])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Org: " + _vm._s(this.$store.state.usermain.curOrg.name))])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('header', {
    attrs: {
      "id": "page-header"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 page-title-wrapper"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("UNIT")]), _vm._v(" "), _c('h2', {
    staticClass: "page-subtitle"
  }, [_vm._v(_vm._s(_vm.currentRoute))])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-body"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    class: {
      'sidebar': true, 'toggled': _vm.mobileSidebarShowing == true ? false : true
    },
    attrs: {
      "id": "page-sidebar"
    }
  }, [_c('nav', {
    staticClass: "sidebar-collapse hidden-sm-down"
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-pills nav-stacked flex-column",
    attrs: {
      "id": "sidebar-stacked"
    }
  }, [_c('li', {
    staticClass: "hidden-md-up"
  }, [_c('a', {
    staticClass: "sidebar-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.mobileSidebarShowing = false
      }
    }
  }, [_c('i', {
    staticClass: "ion ion-ios-arrow-back"
  })])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "exact-active-class": "active",
      "to": "/"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_c('i', {
    staticClass: "ion ion-ios-home"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Home")])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.subIsActive('/operations')
    }
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-pills nav-stacked flex-column collapse",
    attrs: {
      "id": "p2"
    }
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/operations/workflows"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_vm._v("Workflows")])]), _vm._v(" "), (_vm.org['curOrg']['role'] == 99) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/operations/archivedworkflows"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_vm._v("Archived Workflows")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "exact-active-class": "active",
      "to": "/operations/wire"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_vm._v("Wire")])])], 1)]), _vm._v(" "), (_vm.org['curOrg']['role'] == '2' || _vm.org['curOrg']['role'] == '1' || _vm.org['curOrg']['role'] == 99) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.subIsActive('/insights')
    }
  }, [_vm._m(4), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-pills nav-stacked flex-column collapse",
    attrs: {
      "id": "p3"
    }
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "exact-active-class": "active",
      "to": "/insights/datavisualization"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_vm._v("Data Visualization")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.org['curOrg']['role'] == 99) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.subIsActive('/inventory')
    }
  }, [_vm._m(5), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-pills nav-stacked flex-column collapse",
    attrs: {
      "id": "p4"
    }
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "exact-active-class": "active",
      "to": "/inventory/assets"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_vm._v("Assets")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "exact-active-class": "active",
      "to": "/inventory/groups"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_vm._v("Groups")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.org['curOrg']['role'] == '2' || _vm.org['curOrg']['role'] == '1' || _vm.org['curOrg']['role'] == 99) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.subIsActive('/admin')
    }
  }, [_vm._m(6), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-pills nav-stacked flex-column collapse",
    attrs: {
      "id": "p5"
    }
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "exact-active-class": "active",
      "to": "/admin/users"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_vm._v("Users")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "exact-active-class": "active",
      "to": "/admin/devices"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_vm._v("Devices")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "exact-active-class": "active",
      "to": "/admin/workflowattributes"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_vm._v("Workflow Attributes")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "exact-active-class": "active",
      "to": "/admin/workflowgroups"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_vm._v("Workflow Groups")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.org['curOrg']['role'] == 99) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.subIsActive('/stanadmin')
    }
  }, [_vm._m(7), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-pills nav-stacked flex-column collapse",
    attrs: {
      "id": "p6"
    }
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "exact-active-class": "active",
      "to": "/stanadmin/organizations"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_vm._v("Organizations")])])], 1)]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-content"
    }
  }, [_c('router-view'), _vm._v(" "), _c('footer', {
    staticClass: "text-center",
    attrs: {
      "id": "footer"
    }
  }, [_c('p', [_vm._v("© " + _vm._s(_vm.moment().format('YYYY')) + " UNIT Portal")]), _vm._v(" "), _vm._m(8)])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-brand"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/img/UNITLogo.png"),
      "height": "105px",
      "width": "105px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-brand hidden-sm-down",
    attrs: {
      "href": "index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/img/UNITLogo.png"),
      "height": "80px",
      "width": "80px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "target": "_blank",
      "href": "http://premises.support.unitdynamic.com"
    }
  }, [_c('i', {
    staticClass: "ion ion-help"
  }), _vm._v(" Support Desk")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-container dropdown-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#sidebar-stacked",
      "href": "#p2"
    }
  }, [_c('i', {
    staticClass: "ion ion-ios-clipboard"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Operations")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-container dropdown-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#sidebar-stacked",
      "href": "#p3"
    }
  }, [_c('i', {
    staticClass: "ion ion-ios-stats"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Insights")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-container dropdown-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#sidebar-stacked",
      "href": "#p4"
    }
  }, [_c('i', {
    staticClass: "ion ion-ios-list-box"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Inventory")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-container dropdown-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#sidebar-stacked",
      "href": "#p5"
    }
  }, [_c('i', {
    staticClass: "ion ion-ios-settings"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Management")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-container dropdown-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#sidebar-stacked",
      "href": "#p6"
    }
  }, [_c('i', {
    staticClass: "ion ion-ios-cog"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Stan Admin")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list-inline"
  }, [_c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": "http://premises.support.unitdynamic.com"
    }
  }, [_vm._v("Support")])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": "mailto:support@unitinnovations.com"
    }
  }, [_vm._v("Contact")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 662
// module chunks = 1